import React from 'react'

/**
 * Componente para mostrar la política de analítica (Contenido estático)
 *
 * @component
 */

export const AnalyticNews = (props) => {
  return (
    <div id="analyticNews">
      <div className="container-fluid padding-fluid">
        <h3>ANALYTIC NEWS MONITOREO DE MEDIOS (RAM)</h3>
        <br></br>
        <br></br>
        <p>
          Reconoce la importancia de la privacidad y protección de datos
          personales de los titulares y se compromete a cumplir con los
          estándares de protección de datos personales requeridos. Por lo tanto,
          ha adoptado medidas de confidencialidad y seguridad necesarias para la
          información que le es proporcionada y/o a la que tiene acceso, en
          cumplimiento con lo prescrito en la Ley Orgánica de Protección de
          Datos Personales. El contenido de este documento es estrictamente
          informativo.
          <br></br>
          <br></br>
          <b>OBJETIVO:</b>
          <br></br>
          La presente política tiene como objetivo el informar las condiciones
          bajo las cuales son protegidos y tratados los datos personales de los
          clientes y/o usuarios de la Compañía.
          <br></br>
          <br></br>
          <b>ALCANCE:</b>
          <br></br>
        </p>
        <ul>
          <li>
            La presente política se aplica a todos los canales de comunicación,
            procesos y actividades realizadas por ANALYTIC NEWS MONITOREO DE
            MEDIOS (RAM) de forma manual o electrónica y que incluyan o estén
            relacionados con datos personales.
          </li>
          <li>
            Para efectos de la Ley Orgánica de Protección de Datos Personales,
            la presente política se aplica a todos los tratamientos de datos
            personales realizados por ANALYTIC NEWS MONITOREO DE MEDIOS (RAM).
          </li>
        </ul>
        <p>
          <br></br>
          <b>GLOSARIO DE TÉRMINOS:</b>
          <br></br>
          Dato personal. Dato que identifica o hace identificable a una persona
          natural, directa o indirectamente. Titular. Persona natural cuyos
          datos son objeto de tratamiento. Responsable del tratamiento de datos
          personales. Persona natural o jurídica, pública o privada, autoridad
          pública u otro organismo que solo o conjuntamente con otros decide
          sobre la finalidad y el tratamiento de datos personales. Encargado del
          tratamiento Persona natural o jurídica, pública o privada, autoridad
          pública u otro organismo que solo o conjuntamente con otros trate
          datos personales a nombre y por cuenta de un responsable de un
          tratamiento de datos personales.
          <br></br>
          <br></br>
          <b>Tratamiento de datos personales</b>
          <br></br>
          Cualquier operación o conjunto de operaciones realizadas sobre datos
          personales, ya sea por procedimientos técnicos de carácter
          automatizado, parcialmente automatizado o no automatizado, tales como:
          la recogida, recopilación, obtención, registro, organización,
          estructuración, conservación, custodia, adaptación, modificación,
          eliminación, indexación, extracción, consulta, elaboración,
          utilización, posesión, aprovechamiento, distribución, cesión,
          comunicación o transferencia, o cualquier otra forma de habilitación
          de acceso, cotejo, interconexión, limitación, supresión, destrucción
          y, en general, cualquier uso de datos personales.
          <br></br>
          <br></br>
          <b>FINALIDADES DE TRATAMIENTO Y DATOS QUE SE RECOPILAN:</b>
          <br></br>
          <br></br>
          Finalidades principales:<br></br>
        </p>
        <ul>
          <li>
            Cumplimiento de las condiciones necesarias para la prestación
            efectiva del producto o servicio contratado.
          </li>
          <li>Tramitación de requerimientos y/o reclamos.</li>
          <li>
            Registro, sustento y control de las operaciones derivadas de la
            atención al cliente.
          </li>
          <li>Cumplimiento de obligaciones legales y regulatorias.</li>
        </ul>
        <p>
          <br></br>
          Finalidades secundarias:<br></br>
        </p>
        <ul>
          <li>Analizar y descubrir necesidades de clientes.</li>
          <li>Realizar análisis y mejora de productos y servicios.</li>
          <li>Desarrollar acciones de marketing.</li>
          <li>Realizar estudios de mercado.</li>
          <li>
            Efectuar análisis de satisfacción del cliente e investigaciones
            estadísticas.
          </li>
          <li>Desarrollar acciones comerciales de productos y servicios.</li>
          <li>
            Comercializar y promocionar diferentes productos y servicios
            (incluyendo el envío de publicidad por cualquier medio).
          </li>
          <li>Cumplimiento de obligaciones contractuales.</li>
        </ul>
        <p>
          <br></br>
          <b>TIEMPO DE CONSERVACIÓN:</b>
          <br></br>
          Los Datos personales serán conservados durante un tiempo no mayor al
          necesario para cumplir con la finalidad de su tratamiento. Para
          garantizar que los Datos personales no se conserven más tiempo del
          necesario, el responsable del tratamiento de datos personales
          realizará una revisión de su Base de datos cada cinco años. Los Datos
          personales pueden ser conservados para su tratamiento por un tiempo
          mayor al establecido anteriormente para fines de investigación
          estadística, para lo cual se implementarán garantías de seguridad y
          protección de los Datos personales.
          <br></br>
          <br></br>
          <b>BASE LEGAL PARA EL TRATAMIENTO:</b>
          <br></br>
          Todo tratamiento de datos personales se realiza en estricto
          cumplimiento de acuerdo con el artículo 7 y 8 de la Ley Orgánica de
          Protección de Datos Personales con base en: · Consentimiento del
          titular para el tratamiento de sus datos personales, para una o varias
          finalidades específicas. · El tratamiento es necesario para la
          ejecución de medidas precontractuales a petición del titular o para el
          cumplimiento de obligaciones contractuales perseguidas por el
          responsable del tratamiento de datos personales, encargado del
          tratamiento de datos personales o por un tercero legalmente
          habilitado.
          <br></br>
          <br></br>
          <b>EFECTO DE SUMINISTRAR DATOS PERSONALES ERRÓNEOS O INEXACTOS</b>
          <br></br>
          La negativa de suministrar datos o proporcionar datos inexactos,
          pueden ocasionar que la finalidad para la cual son recopilados no
          pueda cumplirse total o parcialmente. Por lo cual, ANALYTIC NEWS
          MONITOREO DE MEDIOS (RAM) no será responsable de los resultados
          derivados del procesamiento de información que se realicen como
          consecuencia de datos erróneos, desactualizados o inexactos. ANALYTIC
          NEWS MONITOREO DE MEDIOS (RAM) se reserva el derecho a no prestar los
          servicios correspondientes en caso de que se proporcione datos
          erróneos, desactualizados o inexactos.
          <br></br>
          <br></br>
          <b>TRANSFERENCIAS O COMUNICACIONES DE DATOS PERSONALES</b>
          <br></br>
          Para cumplir con las finalidades previamente descritas, los datos
          personales podrán consultarse, compartirse, transferirse y/o
          comunicarse a sus proveedores, subsidiarias, sociedades afiliadas,
          relacionadas y/o auxiliares, empresas encargadas del tratamiento de
          datos y/o sociedades con las que la Compañía mantenga relación a nivel
          nacional o internacional. Para el efecto, ANALYTIC NEWS MONITOREO DE
          MEDIOS (RAM) garantiza que se implementarán medidas técnicas y
          organizativas adecuadas para proteger los datos personales.
          <br></br>
          <br></br>
          <b>EMPRESA COMO RESPONSABLE DE TRATAMIENTO DE DATOS PERSONALES</b>
          <br></br>
          Razón social<br></br>
          ANALYTIC NEWS MONITOREO DE MEDIOS (RAM)<br></br>
          Dirección del domicilio legal<br></br>
          Guipuzcoa E14-46 y Mallorca, Edificio QPH,<br></br>
          Quito - Ecuador<br></br>
          Número de teléfono<br></br>
          023956060<br></br>
          Correo electrónico<br></br>
          delegadodatos_ram@rangle.ec
          <br></br>
          <br></br>
          <b>DERECHOS DE LOS TITULARES</b>
          <br></br>
          Se reconoce a los titulares de datos personales el Acceso y
          Rectificación al tratamiento que se realice sobre la información de
          sus datos personales. Para hacer ejercicio de sus derechos, el
          representante legal o titular de los datos personales podrá acceder,
          rectificar, actualizar, eliminar, oponerse y/o suspender el uso de sus
          datos personales en cualquier momento, de acuerdo con la Ley y
          normativa aplicables. Para ejercer estos derechos, podrá contactar a
          la Compañía a través de los medios habilitados para tal fin. Los
          interesados podrán enviar la solicitud a través de un escrito a
          ANALYTIC NEWS MONITOREO DE MEDIOS (RAM) con la Ref. “Protección de
          datos” de manera física o electrónica, utilizando el formulario para
          la atención de su requerimiento dando clic{' '}
          <a
            target="_blank"
            href="https://apps.qph.com.ec/lopd/pages/public/request.qph?ent=RAM"
          >
            aquí
          </a>
          .<br></br>
          Dirección social<br></br>
          Guipuzcoa E14-46 y Mallorca, Edificio QPH,<br></br>
          Quito - Ecuador<br></br>
          Correo electrónico<br></br>
          delegadodatos_ram@rangle.ec<br></br>
          Horario de atención en oficina<br></br>
          9:00 am a 5:00 pm<br></br>
          Tome en consideración que será necesario que acredite su identidad
          como titular o representante legal del titular para poder realizar el
          trámite. ANALYTIC NEWS MONITOREO DE MEDIOS (RAM) se compromete a
          atender dicha solicitud en un plazo razonable de acuerdo con la Ley y
          normativa aplicables.
          <br></br>
          <br></br>
          <b>PROCEDIMIENTO PARA REVOCAR EL CONSENTIMIENTO</b>
          <br></br>
          El titular o su representante legal puede solicitar la revocación de
          su consentimiento a un tratamiento de datos personales en cualquier
          momento y de forma gratuita. Para lo cual deberá enviar la solicitud a
          través del siguiente formulario el cual puede acceder dando clic aqui.
          Tome en consideración que será necesario que acredite su identidad
          como titular o representante legal del titular para poder realizar el
          trámite. El delegado de protección de datos de ANALYTIC NEWS MONITOREO
          DE MEDIOS (RAM) se comunicará con usted para informar el resultado de
          su solicitud o de ser el caso solicitar información adicional que
          permita validar su identidad o clarificar el tratamiento sobre el cual
          realiza la solicitud.
          <br></br>
          <br></br>
          <b>MEDIDAS DE SEGURIDAD</b>
          <br></br>
          Para proteger los datos personales bajo su responsabilidad, ANALYTIC
          NEWS MONITOREO DE MEDIOS (RAM) ha implementado un sistema de gestión
          de protección de datos personales alineado con el estándar
          internacional ISO/IEC 27701:2019 con base en una adecuada gestión de
          riesgos, adoptando las medidas de control a fin de mantener los datos
          personales en un nivel de protección aceptable que evite de forma
          razonable cualquier consecuencia negativa a los titulares de datos
          personales.
          <br></br>
          <br></br>
          <b>ENCARGATURA DE TRATAMIENTO</b>
          <br></br>
          Cuando ANALYTIC NEWS MONITOREO DE MEDIOS (RAM) realice acuerdos para
          encargar el tratamiento de datos personales, se garantiza que esto se
          realizará en estricto cumplimiento con la Ley Orgánica de Protección
          de Datos Personales.
          <br></br>
          <br></br>
          <b>NOTIFICACIONES Y CAMBIOS EN LA POLÍTICA</b>
          <br></br>
          ANALYTIC NEWS MONITOREO DE MEDIOS (RAM) notificará por los canales
          disponibles la actualización de la presente política y sus cambios de
          forma previa a la entrada en vigor.
          <br></br>
          <br></br>
          <b>USO DE COOKIES</b>
          <br></br>
          ANALYTIC NEWS MONITOREO DE MEDIOS (RAM) utiliza “cookies” para mejorar
          la navegación, calidad de los servicios web y experiencia del usuario.
        </p>
      </div>
    </div>
  )
}
